import React from "react";
import { Button, Spin } from "antd";
import { useAuth } from "react-oidc-context";
import { new_upload_file } from "../../services/FileUploadService";
import { ApiConfig } from "../../services/ConstantService";
import { get_user_groups } from "../../services/SessionTools";

export default function FileUploader() {
  const [selectedFile, setSelectedFile] = React.useState({});
  const [isUploading, setIsUploading] = React.useState(false);


  const auth = useAuth();

  const handleFileSelect = (event) => {
    setSelectedFile(event?.target?.files?.[0]);
  };

  const upload_file_to_service = (event) => {
    const user = auth.user;
    const user_groups = get_user_groups(user);
    const partner_group = user_groups.find((element) =>
      element.includes("csol-11931-users-group-")
    );

    if (!partner_group) {
      console.log("PartnerId is null");
      setIsUploading(false);
      return;
    }

    const partnerid = partner_group.replace("csol-11931-users-group-", "");
    const path_setting = {
      bucket: ApiConfig.bucket,
      pathPrefix: partnerid,
      jiraTicket: "SA-11931",
    };

    new_upload_file(user, path_setting, selectedFile).then((result) => {
      console.log("upload result: ", result);
      setTimeout(() => {
        setSelectedFile(undefined);

        document.getElementById('f1').value = '';
        setIsUploading(false);
      }, 5000);
    });
  };

  return (
    <div>
      <div>
        {isUploading && (
          <div className="loader_overlay">
            <Spin fullscreen />
          </div>
        )}

        <label>
          <input
            type="file"
            onChange={handleFileSelect}
            id="f1" />

          <Button
            data-ttd-inspect-id="user_list_table"
            as="button"
            onClick={() => {
              setIsUploading(true);
              upload_file_to_service();
            }}
            disabled={isUploading}
          >
            Upload File
          </Button>
        </label>
      </div>
    </div>
  );
}
